export default "__VITE_ASSET__Cjg_T4rg__"